var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('transition',{key:"corridor",attrs:{"mode":"out-in","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('router-view',{on:{"play-sound":_vm.playSound}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }